import { render, staticRenderFns } from "./ListRolesForTaskType.vue?vue&type=template&id=1483fc44&scoped=true&"
import script from "./ListRolesForTaskType.vue?vue&type=script&lang=js&"
export * from "./ListRolesForTaskType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483fc44",
  null
  
)

export default component.exports